import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e629064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver fw" }

export function render(_ctx, _cache) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_tabs = _resolveComponent("a-tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      "active-key": _ctx.flowStatus,
      onChange: _ctx.changeTab
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.code,
            tab: item.name + '(' + item.count + ')'
          }, null, 8, ["tab"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active-key", "onChange"])
  ]))
}